import { render, staticRenderFns } from "./AddUserModal.vue?vue&type=template&id=0d08f124&"
import script from "./AddUserModal.vue?vue&type=script&lang=ts&"
export * from "./AddUserModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d08f124')) {
      api.createRecord('0d08f124', component.options)
    } else {
      api.reload('0d08f124', component.options)
    }
    module.hot.accept("./AddUserModal.vue?vue&type=template&id=0d08f124&", function () {
      api.rerender('0d08f124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projectsettings/AddUserModal.vue"
export default component.exports